module.exports = __webpack_public_path__ + "img/acryprint_info2.54f026f7.png";